import kernel from "./inversify.shared.config"
import {ISlideshowBuilder} from "@/Core/SlideshowBuilder";
import {StandaloneAttemptApi} from "@/Api/StandaloneAttemptApi";
kernel.bind<ISlideshowBuilder>("TutorialAttemptApi").to(StandaloneAttemptApi).inSingletonScope();
kernel.bind<ISlideshowBuilder>("ISlideshowBuilder")
    .toDynamicValue(context => context.container.get("TutorialAttemptApi"))
    .inSingletonScope();
export default kernel;